import React from 'react';
import PropTypes from 'prop-types';

import {
  playmakerTeaseStyle as PlaymakerTeaseStylePropType,
} from 'lib/CustomPropTypes';
import { VerticalContext } from 'lib/ContextTypes/vertical';
import {
  getPlaymakerMetadata,
  MSNBC_TVE_PID,
  NEWS_NOW_PID,
  TODAY_ALL_DAY_PID,
} from 'lib/playmaker';

import { PlaymakerTeaseDefault } from './Default';
import { PlaymakerTeaseMSNBC } from './MSNBC';

const block = 'playmaker-tease';

function PlaymakerTease(props) {
  const vertical = React.useContext(VerticalContext);

  const {
    handleStatus,
    hasClickedToPlay,
    icid,
    metadata,
    showDek,
    showTitle,
    stickyEnabled,
    styleOverride,
    useDefault,
  } = props;

  const playmakerMetadata = getPlaymakerMetadata(metadata, vertical);
  const { playmakerId } = playmakerMetadata;

  let PlaymakerComponent;
  if (useDefault || [NEWS_NOW_PID, TODAY_ALL_DAY_PID].includes(playmakerId)) {
    PlaymakerComponent = PlaymakerTeaseDefault;
  } else if ([MSNBC_TVE_PID].includes(playmakerId)) {
    PlaymakerComponent = PlaymakerTeaseMSNBC;
  }

  if (PlaymakerComponent) {
    return (
      <PlaymakerComponent
        block={block}
        handleStatus={handleStatus}
        hasClickedToPlay={hasClickedToPlay}
        icid={icid}
        playmakerMetadata={playmakerMetadata}
        showDek={showDek}
        showTitle={showTitle}
        stickyEnabled={stickyEnabled}
        styleOverride={styleOverride}
        vertical={vertical}
      />
    );
  }

  return null;
}

PlaymakerTease.propTypes = {
  handleStatus: PropTypes.func,
  hasClickedToPlay: PropTypes.bool,
  icid: PropTypes.string,
  metadata: PropTypes.shape({}),
  showDek: PropTypes.bool,
  showTitle: PropTypes.bool,
  stickyEnabled: PropTypes.bool,
  styleOverride: PlaymakerTeaseStylePropType,
  useDefault: PropTypes.bool,
};

PlaymakerTease.defaultProps = {
  handleStatus: Function.prototype,
  hasClickedToPlay: false,
  icid: null,
  metadata: {},
  showDek: true,
  showTitle: true,
  stickyEnabled: false,
  styleOverride: {},
  useDefault: false,
};

export { PlaymakerTease };
